import React, { useContext, useState } from "react";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Content,
  Divider,
  Grid,
  GridItem,
  Level,
  LevelItem,
  Spinner,
  Tooltip
} from "@patternfly/react-core";

import ArrowRightIcon from "@patternfly/react-icons/dist/esm/icons/arrow-right-icon";
import OpenshiftIcon from "@patternfly/react-icons/dist/esm/icons/openshift-icon";
import { RedoIcon } from "@patternfly/react-icons";

import { AuthContext } from "shared/context/AuthContext";

import ProjectInfo from "./Okd/pages/ProjectInfo";

const OkdPanel = ({
  okdData,
  okdLoading,
  refetchOkd
}) => {
  const [refreshCounter, setRefreshCounter] = useState(0);

  const context = useContext(AuthContext);
  const userProfile = context.state.userProfile;

  if (
    !context.state.isAuthUser ||
    !okdData?.projects?.length
  ) {
    return null;
  }

  const okdPortalButton = (
    <Button
      component="a"
      variant="link"
      size="sm"
      icon={<ArrowRightIcon />}
      iconPosition="start"
      target="_blank"
      href="https://console-openshift-console.apps.okd4.zspw.pl"
    >
      Konsola
    </Button>
  );

  const handleRefresh = async () => {
    const refreshed = await refetchOkd();

    if (!refreshed) {
      return;
    }

    setRefreshCounter((value) => value + 1);
  };

  return (
    <Card isCompact isFullHeight>
      <CardTitle>
        <Level>
          <LevelItem>
            <Tooltip content="Openshift: 4.15.0-0">
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px"
                }}
              >
                <OpenshiftIcon
                  style={{
                    transform: "translateY(-1px)"
                  }}
                />

                <span
                  style={{
                    marginLeft: "3px",
                    fontSize: "var(--pf-global--FontSize--sm)"
                  }}
                >
                  Openshift Container Platform
                </span>
              </span>
            </Tooltip>
          </LevelItem>

          <LevelItem>
            <small
              style={{
                fontSize: "12px",
              }}
            >
              Kubernetes: v1.28.2
            </small>
          </LevelItem>

          <LevelItem>
            <small
              style={{
                fontSize: "12px",
              }}
            >
              Openshift: 4.15.0-0
            </small>
          </LevelItem>
        </Level>

        <Divider />
      </CardTitle>

      <CardBody>
        <Level>
          <LevelItem>
            <Content component="h4">
              Twoje aplikacje{" "}
              {userProfile?.is_superuser && okdPortalButton}
            </Content>
          </LevelItem>

          {okdLoading && (
            <LevelItem>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                <Spinner size="sm" />
                <small>Ładowanie...</small>
              </span>
            </LevelItem>
          )}

          <LevelItem>
            <Button
              variant="plain"
              icon={<RedoIcon />}
              onClick={handleRefresh}
              isDisabled={okdLoading}
            />
          </LevelItem>
        </Level>

        {!okdLoading &&
          okdData.projects.map((project) => (
            <Grid
              key={project.name}
              hasGutter
              style={{
                fontSize: "13px",
                lineHeight: "1.6"
              }}
            >
              <GridItem span={12}>
                <ProjectInfo
                  project={project}
                  userProfile={userProfile}
                  refreshCounter={refreshCounter}
                />
              </GridItem>
            </Grid>
          ))}
      </CardBody>
    </Card>
  );
};

export default OkdPanel;